import {mainQuery} from '@github-ui/react-core/future/main-query'
import {copilotAgentsAppBuilder} from '../config/app-builder'
import type {AgentTasksAppPayload} from '@github-ui/agent-sessions/types/agent-tasks-app-payload'
import type {SsoOrganization} from '@github-ui/global-sso-banner-ui/types'

export type CopilotAgentsPayload = AgentTasksAppPayload & {
  hasPaidCopilotAccess: boolean
  ssoOrganizations: SsoOrganization[]
}

export function getAgentsRedirectPath(pathname: string) {
  return pathname.replace(/^\/copilot\/agents(?=\/|$)/, '/copilot')
}

export function getAgentsRedirectLocation({pathname, search, hash}: {pathname: string; search: string; hash: string}) {
  return `${getAgentsRedirectPath(pathname)}${search}${hash}`
}

export function createCopilotAgentsRoute(path: string) {
  return copilotAgentsAppBuilder.createQueryRouteConfig('copilotAgentsRoute', {
    path,
    queries: [mainQuery<CopilotAgentsPayload>()],
  })
}

export const copilotAgentsRoute = createCopilotAgentsRoute('/copilot/agents')
export const canonicalCopilotAgentsRoute = createCopilotAgentsRoute('/copilot')
